import { ArrowBack } from "@mui/icons-material"
import CreditCardIcon from "@mui/icons-material/CreditCard"
import { Box, Button, Card, Grid, Stack, Typography } from "@mui/material"
import moment from "jalali-moment"
import Link from "next/link"
import { DEFAULT_GIFT_CREDIT_FLOW } from "../../../../../constants/giftCredit"

const CreditListItem = ({ credit }) => {
  const { createDate, creditAmount, giftCreditRequestGuid, statusName } = credit || {}
  return (
    <Grid item xs={12} mt={1} p={1}>
      <Card variant='outlined'>
        <Box display='flex' justifyContent='space-between' alignItems='center' p={1}>
          <Box display='flex' gap={1}>
            <CreditCardIcon />
            <Stack>
              <Box>
                <Typography variant='caption'>تاریخ ثبت: </Typography>
                <Typography variant='caption'>{moment(createDate).locale("fa").format("DD MMMM YYYY")}</Typography>
              </Box>
              <Box>
                <Typography variant='caption'>وضعیت: </Typography>
                <Typography variant='caption'>{statusName} </Typography>
              </Box>
              <Box>
                <Typography variant='caption'>مبلغ اعتبار: </Typography>
                <Typography variant='caption'>
                  {creditAmount ? `${creditAmount?.toLocaleString()} ریال ` : "-"}
                </Typography>
              </Box>
            </Stack>
          </Box>
          <Button
            variant='outlined'
            color='primary'
            component={Link}
            size='small'
            href={`${DEFAULT_GIFT_CREDIT_FLOW}/${giftCreditRequestGuid}`}
            endIcon={<ArrowBack />}
          >
            جزئیات
          </Button>
        </Box>
      </Card>
    </Grid>
  )
}

export default CreditListItem
